const animation = {
  duration: 0.2,
};

export default animation;
